import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "min-h-screen flex flex-col bg-gray-200"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_FooterSection = _resolveComponent("FooterSection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "flex-grow bg-cover bg-center bg-no-repeat",
      style: _normalizeStyle({ backgroundImage: 'url(' + require(`@/assets/formulario.jpg`) + ')' })
    }, [
      _createVNode(_component_router_view)
    ], 4),
    _createVNode(_component_FooterSection)
  ]))
}